import React from 'react';
import { Link } from 'react-router-dom';

const CopyrightFooter: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="text-center text-[13px] text-fg-dim py-5 mt-10">
      <div className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-3">
        <span>&copy; {currentYear} Solofix</span>
        <span className="hidden sm:inline">·</span>
        <Link
          to="/algemene-voorwaarden"
          className="hover:text-fg-muted transition-colors"
        >
          Algemene voorwaarden
        </Link>
        <span className="hidden sm:inline">·</span>
        <Link
          to="/privacy-statement"
          className="hover:text-fg-muted transition-colors"
        >
          Privacy statement
        </Link>
      </div>
    </footer>
  );
};

export default CopyrightFooter;
